import React, { useEffect, useState, useRef } from 'react'
import ExtrasList from './ExtrasList.js'
import { postData } from '../../../../js/helpers/apiHelper'
import ModalCase1 from '../ExtrasModals/ModalCase1.js'
import ModalCase2 from '../ExtrasModals/ModalCase2.js'
import ModalCase3 from '../ExtrasModals/ModalCase3.js'
import ModalCase4 from '../ExtrasModals/ModalCase4.js'
import constants from '../../../../js/lib/constants.js'
import { useSelector, useDispatch } from 'react-redux'
import {
  setSelectedExtras,
  setSelectedVehicle,
} from '../../../../js/lib/redux/slices/booking.js'
import * as lib from '../../../../js/lib/lib.js'
import Alert from '../../Base/Alert'

const ExtrasApp = ({ onSetSelectedExtras = () => {}, extrasEndpoint, parentCollapseOpen = true }) => {
  const { configuration, dictionary, token } =
    window.bookingData || window.modifyData || window.inpathData

  const {
    selectedVehicle,
    selectedExtras,
    isPrepaid: isPrepaidStore,
    type,
  } = useSelector((state) => state.booking)

  // console.log('selectedvehicle', selectedVehicle)

  const { prepaidPrice, returnPrice } = selectedVehicle.car || {}
  const [inpathResponseData, setInpathResponseData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [alertMessages, setAlertMessages] = useState([])
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState([])
  const dispatch = useDispatch()

  // useEffect(() => {
  //   console.log('selectedExtras', selectedExtras)
  // }, [selectedExtras])

  const amenitiesDefinitions = () => {
    if (isPrepaidStore) {
      return prepaidPrice.amenities
    } else {
      return returnPrice.amenities
    }
  }

  const amenitiesPrerequisites = () => {
    return amenitiesDefinitions().flatMap((i) => {
      const prerequisites = i.prerequisites ?? []
      if (prerequisites.length === 0) {
        return []
      }
      return {
        id: i.code,
        prereqsIds: prerequisites,
        exemption: i.dailyRate,
      }
    })
  }

  const selectedIds = () => {
    return selectedExtras.map((i) => i.code)
  }

  const unselectedIds = () => {
    return amenitiesDefinitions()
      .filter((i) => !selectedIds().includes(i.code))
      .map((i) => i.code)
  }

  const amenityIsSelected = (item) => {
    return selectedIds().includes(item.code)
  }

  const getAmenityQuantity = (item) => {
    if (!amenityIsSelected(item)) {
      return 0
    }
    const entry = selectedExtras.find((i) => i.code === item.code)
    return entry.quantity
  }

  const getAmenityAddedType = (item) => {
    if (!amenityIsSelected(item)) {
      return constants.extras.manually
    }
    const entry = selectedExtras.find((i) => i.code === item.code)
    return entry.added
  }

  const getAmenities = () => {
    return amenitiesDefinitions().map((i) => ({
      Code: i.code,
      Quantity: getAmenityQuantity(i),
      Added: getAmenityAddedType(i),
    }))
  }

  const handleAddExtra = (code, quantity) => {
    if (isCase1(code)) {
      return false
    }

    if (isCase2(code)) {
      return false
    }

    const updatedExtras = [
      ...selectedExtras,
      {
        code: code,
        quantity: Number(quantity),
        added: constants.extras.manually,
      },
    ]

    // onSetSelectedExtras(inpathResponseData)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }
  const handleRemoveExtra = (code) => {
    if (isCase3(code)) {
      return false
    }

    if (isCase4(code)) {
      return false
    }

    const updatedExtras = selectedExtras.filter((item) => item.code !== code)

    // onSetSelectedExtras(inpathResponseData)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }

  const fetchData = async (proposedExtras) => {
    const payload = {
      amenities: proposedExtras.map(({ code, quantity }) => ({
        Code: code,
        Quantity: quantity,
      })),
      vehicleGroup: selectedVehicle.car.name,
      rateReference: selectedVehicle.rateReference,
      brandCode: selectedVehicle.brandName,
      acriss: selectedVehicle.car.acriss,
      isPrepaid: isPrepaidStore,
      token: token,
    }

    if (!window.bookingData && !window.inpathData) return
    try {
      setIsLoading(true)

      const response = await postData(extrasEndpoint, payload)

      const {
        success,
        errorCode,
        errorDescription,
        vehicle,
        hasError,
        errorMessages,
        data,
      } = response

      console.log('type ' + type)

      if (type === 'inpath') {
        if (hasError) {
          handleError(errorMessages)
          return
        }

        // setInpathResponseData(data.inpathData)
        dispatch(setSelectedExtras(proposedExtras))
        onSetSelectedExtras(data.inpathData)
      } else {
        if (
          !success &&
          errorCode?.trim() !== '' &&
          errorCode?.trim() !== undefined &&
          errorCode?.trim() !== null &&
          vehicle?.extraData?.length > 0
        ) {
          // Show the error modal
          setErrorMessage(vehicle.extraData.map((i) => i.dataValue))
          setShowErrorModal(true)
          return
        } else if (
          !success &&
          errorCode?.trim() !== '' &&
          errorCode?.trim() !== undefined &&
          errorCode?.trim() !== null
        ) {
          handleError([errorCode, errorDescription])
          return
        } else if (!success) {
          handleError(errorDescription)
          return
        }

        dispatch(setSelectedVehicle(vehicle))
        dispatch(setSelectedExtras(proposedExtras))
      }

      handleSuccess()
    } catch (err) {
      console.error(err)
      handleError([err])
    }
  }

  const handleSuccess = () => {
    setAlertMessages([])
    setIsLoading(false)
  }

  const handleError = (messages) => {
    typeof messages === 'string'
      ? setAlertMessages([messages])
      : setAlertMessages(messages)
    setIsLoading(false)

    setTimeout(() => {
      lib.scrollToError(110)
    }, 0)
  }

  const [case1Master, setCase1Master] = useState(null)
  const [case1Childs, setCase1Childs] = useState([])
  const [case2Master, setCase2Master] = useState(null)
  const [case2Child, setCase2Child] = useState(null)
  const [case2Exemption, setCase2Exemption] = useState(null)
  const [case3Master, setCase3Master] = useState(null)
  const [case3Childs, setCase3Childs] = useState([])
  const [case4Master, setCase4Master] = useState(null)
  const [case4Child, setCase4Child] = useState(null)

  const [isModal1Open, setIsModal1Open] = useState(false)
  const [isModal2Open, setIsModal2Open] = useState(false)
  const [isModal3Open, setIsModal3Open] = useState(false)
  const [isModal4Open, setIsModal4Open] = useState(false)

  const isCase1 = (code) => {
    const entry = amenitiesPrerequisites().find((i) => i.id === code)
    if (entry) {
      const prereqs = entry.prereqsIds

      const atLeastOnePrereqIsUnSelected = prereqs.some((x) =>
        unselectedIds().includes(x)
      )

      if (atLeastOnePrereqIsUnSelected) {
        setCase1Master(code)
        setCase1Childs(prereqs.filter((i) => unselectedIds().includes(i)))
        setIsModal1Open(true)
        // console.log('CASE 1')

        return true
      }
    }
    return false
  }

  const isCase2 = (code) => {
    const entry = amenitiesPrerequisites().find((i) =>
      i.prereqsIds.includes(code)
    )

    if (entry) {
      setCase2Master(entry.id)
      setCase2Child(code)
      setCase2Exemption(entry.exemption)
      const masterIsSelected = selectedIds().includes(entry.id)

      const selectedIdsTmp = [...selectedIds(), code]

      const allPrereqsAreSelected = entry.prereqsIds.every((i) =>
        selectedIdsTmp.includes(i)
      )

      if (allPrereqsAreSelected && !masterIsSelected) {
        setIsModal2Open(true)
        // console.log('CASE 2')

        return true
      }
    }
    return false
  }

  const isCase3 = (code) => {
    const entry = amenitiesPrerequisites().find((i) => i.id === code)
    if (entry) {
      const prereqs = entry.prereqsIds

      const prereqsSelectedAuto = selectedExtras
        .filter((i) => i.added === constants.extras.auto)
        .filter((i) => prereqs.includes(i.code))
        .map((i) => i.code)

      if (prereqsSelectedAuto.length) {
        setCase3Master(code)
        setCase3Childs(prereqsSelectedAuto)
        setIsModal3Open(true)
        // console.log('CASE 3')

        return true
      }
    }
    return false
  }

  const isCase4 = (code) => {
    const entry = amenitiesPrerequisites().find((i) =>
      i.prereqsIds.includes(code)
    )
    if (entry) {
      const masterIsSelected = selectedIds().includes(entry.id)

      if (masterIsSelected) {
        setCase4Master(entry.id)
        setCase4Child(code)
        setIsModal4Open(true)
        // console.log('CASE 4')

        return true
      }
    }
    return false
  }

  const onSubmitCase1 = (masterId, childsIds) => {
    const updatedExtras = [
      ...selectedExtras,
      { code: masterId, quantity: 1, added: constants.extras.manually },
      ...childsIds.map((elem) => ({
        code: elem,
        quantity: 1,
        added: constants.extras.auto,
      })),
    ]

    setIsModal1Open(false)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }

  const onSubmitCase2 = (masterId, childId) => {
    const updatedExtras = [
      ...selectedExtras,
      { code: childId, quantity: 1, added: constants.extras.manually },
      { code: masterId, quantity: 1, added: constants.extras.auto },
    ]

    setIsModal2Open(false)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }

  const onSubmitCase3 = (masterId, childsIds) => {
    const updatedExtras = selectedExtras.filter(
      (item) => item.code !== masterId && !childsIds.includes(item.code)
    )
    setIsModal3Open(false)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }

  const onSubmitCase4 = (masterId, childId) => {
    const updatedExtras = selectedExtras.filter(
      (item) => item.code !== masterId && item.code !== childId
    )
    setIsModal4Open(false)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }

  const onUndoCase1 = () => {
    setIsModal1Open(false)
  }

  const onUndoCase2 = (code) => {
    const updatedExtras = selectedExtras.filter((item) => item.code !== code)
    setIsModal2Open(false)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }

  const onUndoCase3 = (code) => {
    const updatedExtras = selectedExtras.filter((item) => item.code !== code)
    setIsModal3Open(false)
    if (type === 'modify') dispatch(setSelectedExtras(updatedExtras))
    else fetchData(updatedExtras)
  }

  const onUndoCase4 = () => {
    setIsModal4Open(false)
  }

  return (
    <>
      {alertMessages.length > 0 && <Alert messages={alertMessages} />}
      <ExtrasList
        dictionary={dictionary}
        isLoading={isLoading}
        onAddExtra={handleAddExtra}
        onRemoveExtra={handleRemoveExtra}
        parentCollapseOpen={parentCollapseOpen}
      />

      <ModalCase1
        amenitiesDefinitions={amenitiesDefinitions()}
        dictionary={dictionary}
        isOpen={isModal1Open}
        master={case1Master}
        childs={case1Childs}
        onSubmit={onSubmitCase1}
        onUndo={onUndoCase1}
      />

      <ModalCase2
        amenitiesDefinitions={amenitiesDefinitions()}
        dictionary={dictionary}
        isOpen={isModal2Open}
        master={case2Master}
        child={case2Child}
        exemption={case2Exemption}
        onSubmit={onSubmitCase2}
        onUndo={onUndoCase2}
      />

      <ModalCase3
        amenitiesDefinitions={amenitiesDefinitions()}
        dictionary={dictionary}
        isOpen={isModal3Open}
        master={case3Master}
        childs={case3Childs}
        onSubmit={onSubmitCase3}
        onUndo={onUndoCase3}
      />

      <ModalCase4
        amenitiesDefinitions={amenitiesDefinitions()}
        dictionary={dictionary}
        isOpen={isModal4Open}
        master={case4Master}
        child={case4Child}
        onSubmit={onSubmitCase4}
        onUndo={onUndoCase4}
      />

      <div
        className={`modal s-modal s-modal--warning  ${
          showErrorModal ? 'show d-block' : ''
        }`}
        id="modalCaseError">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn btn-close"
                onClick={() => setShowErrorModal(false)}
                aria-label={dictionary.modalErrorCloseText}>
                <i className="icon-x"></i>
              </button>
              <div className="modal-title">
                <div>{dictionary.modalErrorTitle}</div>
              </div>
            </div>
            <div className="modal-body">
              <ul className="b-extras-as-badges-list">
                {errorMessage.map((child, index) => (
                  <li key={index}>
                    <div className="e-extra-as-badge">{child}</div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowErrorModal(false)}
                title={dictionary.modalErrorCloseText}>
                {dictionary.modalErrorCloseText}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modal backdrop */}
      {showErrorModal && <div className="modal-backdrop fade show"></div>}
    </>
  )
}

export default ExtrasApp
